<template>
  <div id="app">
    <div id="chinaMap" style="height: 600px; width: 800px" ref="myEchart"></div>
    <!-- <div id="myChart" style="width: 100%;height:400px;"></div> -->
  </div>
</template>

<script>
var echarts = require("echarts/lib/echarts");
require("echarts/map/js/china"); // 引入中国地图数据
export default {
  name: "App",
  data(){
    return {

    }
  },
  mounted() {
    console.log(this.allCity)
    this.chinamap(this.allCity);
  },
  props:{
    allCity: {
       type: Array,
       default: []
    }
  },
  watch:{
     allCity(){
       this.chinamap(this.allCity);
     }
  },
  methods: {
    chinamap(list) {
      let x = []
      list.forEach(lists => {
         if(lists.eventName.indexOf("省")> -1){
           lists.eventName=lists.eventName.substr(0,lists.eventName.length-1)
         }
      })
      var myChart = echarts.init(document.getElementById("chinaMap"));
      window.addEventListener("resize", function () {
        myChart.resize();
      });
      let arrs = [];
      list.forEach(item => {
          arrs.push({
            name: item.eventName,
            value: parseInt(item.eventValue) 
          })
      }); 

      var option = {
        backgroundColor: "#FFFFFF", //设置背景颜色
        title: {
          show: true,
          text: "中国省地图",
          subtext: "",
          left: "left",
        },
        tooltip: {
          trigger: "item",
        },
        //左侧小导航图标
        visualMap: {
          show: true,
          x: "left",
          y: "bottom",
          splitList: [
            { start: 20, end: 50 },
            { start: 1, end: 20 },
            { start: 0, end: 0 },
          ],
          color: ["#1E90FF", "#77B4F1", "#DDF8FF"],
        },
        //配置属性
        series: [
          {
            name: "访问人数",
            type: "map",

            map: "china",
            roam: false,
            zoom: 1.2,
            label: {
                normal: {
                    show: true,
                },
                emphasis: {
                    show: false
                }
            },
            data: [
              { name: "北京", value: 0 },
              { name: "天津", value: 0 },
              { name: "上海", value: 0 },
              { name: "重庆", value: 0 },
              { name: "河北", value: 0 },
              { name: "河南", value: 0 },
              { name: "云南", value: 0 },
              { name: "辽宁", value: 0 },
              { name: "黑龙江", value: 0 },
              { name: "湖南", value: 0 },
              { name: "安徽", value: 0 },
              { name: "山东", value: 0 },
              { name: "新疆", value: 0 },
              { name: "江苏", value: 0 },
              { name: "浙江", value: 0 },
              { name: "江西", value: 0 },
              { name: "湖北", value: 0 },
              { name: "广西", value: 0 },
              { name: "甘肃", value: 0 },
              { name: "山西", value: 0 },
              { name: "内蒙古", value: 0 },
              { name: "陕西", value: 0 },
              { name: "吉林", value: 0 },
              { name: "福建", value: 0 },
              { name: "贵州", value: 0 },
              { name: "广东", value: 0 },
              { name: "青海", value: 0 },
              { name: "西藏", value: 0 },
              { name: "四川", value: 0 },
              { name: "宁夏", value: 0 },
              { name: "海南", value: 0 },
              { name: "台湾", value: 0 },
              { name: "香港", value: 0 },
              { name: "澳门", value: 0 },
            ],
          },
        ],
      };

      var newData = [];
      list.forEach(item => {
          newData.push({
            name: item.eventName,
            value: parseInt(item.eventValue) 
          })
      }); 
      

      console.log(newData)
      newData.forEach((list,indexs) => {
          option.series[0].data.forEach((items,index) => {
            if(list.name === items.name){
                items.value = list.value
            }
          })
      })
      console.log(option)
      /**
       *  使用刚指定的配置项和数据显示图表。
       *  */
      myChart.setOption(option);
    },
  },
  created() {

  }
};
</script>
